import HoursInformation from 'components/Content/Happening/StoreDetails/HoursInformation/HoursInformation';

export default HoursInformation;
